// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_SalvaCidadeInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /localidades/salvaCidade
 *
 * Creates or updates a city in the locations service.
 */
import { registerContract } from './validate'

export interface Localidades_SalvaCidadeInput {
cidade_nome: string
estado_id: number
cidade_id?: number
}

registerContract('Localidades_SalvaCidadeInput', {
  cidade_nome: { type: 'string',  required: true },
  estado_id:   { type: 'number',  required: true },
  cidade_id:   { type: 'number',  required: false },
})
